import { useState } from 'react';

const testimonials = [
  {
    name: 'Jennifer M.',
    location: 'Snellville, GA',
    service: 'Carpet Cleaning',
    text: 'Carpet & Flooring Transformers did an incredible job on our carpets. We have two dogs and the pet odor was completely eliminated. The technician was professional, on time, and the results were better than I expected. Will absolutely use them again.',
    stars: 5,
  },
  {
    name: 'Marcus T.',
    location: 'Lawrenceville, GA',
    service: 'LVP Installation',
    text: 'Had luxury vinyl plank installed throughout my entire first floor. The team was meticulous, cleaned up after themselves, and the finished product looks stunning. Pricing was fair and transparent — no surprises. Highly recommend.',
    stars: 5,
  },
  {
    name: 'Sandra K.',
    location: 'Duluth, GA',
    service: 'Tile & Grout Cleaning',
    text: 'I could not believe the difference after they cleaned my tile and grout. It looks brand new. I had tried everything myself and nothing worked. These guys are the real deal. Professional, efficient, and genuinely nice people.',
    stars: 5,
  },
  {
    name: 'David R.',
    location: 'Grayson, GA',
    service: 'Carpet Repair',
    text: 'Had a large tear in my carpet from moving furniture. They came out, assessed it, and repaired it perfectly. You can\'t even tell it was ever damaged. Fast turnaround and very reasonable pricing. Great local company.',
    stars: 5,
  },
  {
    name: 'Patricia L.',
    location: 'Norcross, GA',
    service: 'Hardwood Refinishing',
    text: 'Our hardwood floors were scratched and dull after 15 years. Carpet Transformers refinished them and they look absolutely gorgeous — like the day we moved in. The crew was respectful of our home and incredibly skilled.',
    stars: 5,
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="w-4 h-4 flex items-center justify-center text-amber-500">
          <i className="ri-star-fill text-sm"></i>
        </div>
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">Client Stories</p>
            <h2 className="font-serif text-4xl md:text-5xl text-stone-900">What Our Clients Say</h2>
          </div>
          <div className="flex items-center gap-3">
            <Stars count={5} />
            <span className="text-stone-800 font-bold text-lg">5.0</span>
            <span className="text-stone-400 text-sm">Google Verified</span>
          </div>
        </div>

        {/* Desktop: 3 cards */}
        <div className="hidden lg:grid grid-cols-3 gap-6 mb-10">
          {testimonials.slice(0, 3).map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-8 border border-stone-100 flex flex-col">
              <Stars count={t.stars} />
              <p className="text-stone-600 text-sm leading-relaxed mt-5 mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="border-t border-stone-100 pt-5 flex items-center justify-between">
                <div>
                  <p className="font-bold text-stone-900 text-sm">{t.name}</p>
                  <p className="text-stone-400 text-xs mt-0.5">{t.location}</p>
                </div>
                <span className="text-[11px] font-semibold text-amber-600 bg-amber-50 px-3 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: 2 more cards */}
        <div className="hidden lg:grid grid-cols-2 gap-6 mb-14">
          {testimonials.slice(3).map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-8 border border-stone-100 flex flex-col">
              <Stars count={t.stars} />
              <p className="text-stone-600 text-sm leading-relaxed mt-5 mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="border-t border-stone-100 pt-5 flex items-center justify-between">
                <div>
                  <p className="font-bold text-stone-900 text-sm">{t.name}</p>
                  <p className="text-stone-400 text-xs mt-0.5">{t.location}</p>
                </div>
                <span className="text-[11px] font-semibold text-amber-600 bg-amber-50 px-3 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile: carousel */}
        <div className="lg:hidden mb-10">
          <div className="bg-white rounded-2xl p-7 border border-stone-100 mb-5">
            <Stars count={testimonials[active].stars} />
            <p className="text-stone-600 text-sm leading-relaxed mt-5 mb-6">&ldquo;{testimonials[active].text}&rdquo;</p>
            <div className="border-t border-stone-100 pt-5 flex items-center justify-between">
              <div>
                <p className="font-bold text-stone-900 text-sm">{testimonials[active].name}</p>
                <p className="text-stone-400 text-xs mt-0.5">{testimonials[active].location}</p>
              </div>
              <span className="text-[11px] font-semibold text-amber-600 bg-amber-50 px-3 py-1 rounded-full whitespace-nowrap">{testimonials[active].service}</span>
            </div>
          </div>
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() => setActive((a) => (a === 0 ? testimonials.length - 1 : a - 1))}
              className="w-9 h-9 flex items-center justify-center border border-stone-300 rounded-full text-stone-600 hover:border-amber-600 hover:text-amber-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-sm"></i>
            </button>
            <div className="flex gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`rounded-full transition-all cursor-pointer ${i === active ? 'w-5 h-2 bg-amber-600' : 'w-2 h-2 bg-stone-300'}`}
                />
              ))}
            </div>
            <button
              onClick={() => setActive((a) => (a === testimonials.length - 1 ? 0 : a + 1))}
              className="w-9 h-9 flex items-center justify-center border border-stone-300 rounded-full text-stone-600 hover:border-amber-600 hover:text-amber-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </div>
        </div>

        {/* Post-testimonials CTA */}
        <div className="text-center">
          <p className="text-stone-500 text-base mb-5">Join hundreds of satisfied Metro Atlanta homeowners.</p>
          <a
            href="#estimate-form"
            className="inline-flex items-center gap-2 bg-stone-900 hover:bg-amber-700 text-white font-bold text-sm px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Your Free Estimate Today
          </a>
        </div>
      </div>
    </section>
  );
}
